import { getStorageItem, setStorageItem } from '../storage/indexed-db';

const manifestDirectoryUrl = (manifestUrl: string) => {
  const parts = manifestUrl.split('/');
  parts.pop();
  return parts.join('/');
};

const isMaster = (manifestBody: string) => {
  return manifestBody.includes('#EXT-X-STREAM-INF:');
};

const firstPlaylist = (manfiestBody: string) => {
  const lines = manfiestBody.split('\n');
  const len = lines.length;
  for (let i = 0; i < len; i++) {
    if (lines[i].includes('#EXT-X-STREAM-INF:')) {
      return lines[i + 1];
    }
  }
  return undefined;
};

const durationFromPlaylist = (playlistBody: string) => {
  const lines = playlistBody.split('\n');
  let duration = 0;
  // duration of each segment is stored on the playlist preceeding the URI of the
  // segment, formatted as `#EXTINF:10.0000,` where "10.0000" is the duration of
  // the segment in seconds. Just add them all up and that's the video duration.
  for (const line of lines) {
    if (line.startsWith('#EXTINF:')) {
      const lineDur = Number(line.replace(/#EXTINF:|,/g, ''));
      if (!isNaN(lineDur)) {
        duration += lineDur;
      }
    }
  }
  return duration;
};

// NOTE: this should NOT be used for live manfiests as the duration changes on the fly.
// only use for recorded HLS manifests.
export const getDurationOfHlsFromManifest = async (url: string) => {
  try {
    let playlist: string;

    // check if we've cached this and just skip resolving and parsing the playlists
    const cached = await getStorageItem(`durations:${url}`);
    if (cached) {
      const dur = Number(cached);
      if (!isNaN(dur)) {
        return dur;
      }
    }

    // may be either a master.m3u8 which points to one or more playlists OR might be a playlist itself
    const initialManfiest = await fetch(url).then((res) => {
      if (res.ok) {
        return res.text();
      }

      throw res.statusText;
    });

    // if it's a master manifest, load the first playlist in the manifest (they should all be the same duration)
    if (isMaster(initialManfiest)) {
      const playlistPath = firstPlaylist(initialManfiest);
      const directory = manifestDirectoryUrl(url);
      playlist = await fetch(`${directory}/${playlistPath}`).then((res) => {
        if (res.ok) {
          return res.text();
        }

        throw res.statusText;
      });
    } else {
      // not a master playlist, so just treat this as the playlist m3u8
      playlist = initialManfiest;
    }

    const duration = durationFromPlaylist(playlist);
    await setStorageItem(`durations:${url}`, String(duration), 72);
    return duration;
  } catch (e) {
    console.error(e);
    return 0;
  }
};
